module.exports = __webpack_public_path__ + "static/media/2.81e4c170.jpg";